<template>
  <div class="content-area">
    <hero-bar>
      {{ $t('createCar') }}

      <b-button
        slot="right"
        icon-left="content-save"
        type="is-link"
        :class="{ 'is-loading': isLoading }"
        @click="save"
      >
        {{ $t('save') }}
      </b-button>
    </hero-bar>

    <section class="section is-main-section">
      <card-component :title="$t('carDetails')" icon="car-info">
        <form>
          <b-field horizontal :label="$t('txtstatus')">
            <b-switch v-model="car.ready" type="is-purple" :true-value="1" :false-value="0" expanded />
          </b-field>

          <b-field horizontal :label="$t('plate')">
            <b-input v-model="car.plate" :placeholder="$t('plate')" expanded />
          </b-field>

          <b-field horizontal :label="$t('seats')">
            <b-input v-model="car.seats" :placeholder="$t('seats')" expanded />
          </b-field>

          <b-field horizontal :label="$t('owner')">
            <b-select v-model="car.owner" :placeholder="$t('owner')" expanded>
              <option value="Kurum">Kurum</option>
              <option value="Diğer">Diğer</option>
            </b-select>
          </b-field>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'

export default {
  title: ({ $i18n }) => $i18n.t('createCar'),
  components: {
    HeroBar,
    CardComponent,
  },
  data () {
    return {
      isLoading: false,
      car: {
        ready: 0,
        plate: null,
        seats: null,
        owner: null,
      },
    }
  },
  mounted () {
    this.$store.commit('setAsideActiveMenuKey', 'cars.index')
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  methods: {
    save () {
      this.isLoading = true;

      const body = this.$_.pick(this.car, ['ready', 'plate', 'seats', 'owner']);

      this.$http.post('cars/store', body).then(() => {
        this.$buefy.toast.open({
          message: this.$t('carCreated'),
          type: 'is-success',
          queue: false,
        });
      }).catch((error) => {
        const errors = this.$_.flattenDeep(this.$_.values(error.response.data.errors).join('<br>'));

        this.$buefy.toast.open({
          message: `${this.$t('error')}:<br>${errors}`,
          type: 'is-warning',
          queue: false,
        });
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
}
</script>
